<template>
  <JoszakiAutocomplete
    ref="cityAutocomplete"
    v-bind="$attrs"
    :value="value"
    :icon="icon"
    :items="filteredCities"
    :keep-first="keepFirst"
    :placeholder="value?.name ?? placeholder ?? ''"
    :label="showLabel ? label ?? $t('common.city') : null"
    :loading="loading"
    :disable-sort="true"
    v-on="$listeners"
    @focus="onFocus"
    @search="onSearch"
    @input="$emit('input', $event)"
  >
    <template #empty>
      <slot name="empty">
        {{ $t("cityAutocomplete.empty") }}
      </slot>
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref, useContext } from "@nuxtjs/composition-api";
import { useCitySearch } from "~/composables/useCitySearch";

export default {
  props: {
    value: {
      type: [Object, Array],
      default: () => null,
    },
    keepFirst: {
      type: Boolean,
      default: true,
    },
    filterCapitol: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "map-marker-alt",
    },
    placeholder: {
      type: String,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    typingTrackerEvent: {
      type: String,
      default: null,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    allowedCityIds: {
      type: Array,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { $trackers } = useContext();
    const openOnFocus = ref(true);

    const citySearch = useCitySearch(props.filterCapitol);

    const onSearch = (search) => {
      citySearch.debouncedCityFilter.value = search;
      if (!search || search.length < 3 || !props.typingTrackerEvent) {
        return;
      }

      $trackers.trackEvent({
        title: props.typingTrackerEvent,
        data: { value: search },
      });
      emit("search", search);
    };

    return {
      openOnFocus,
      onSearch,
      ...citySearch,
    };
  },
  computed: {
    filteredCities() {
      if (!this.allowedCityIds?.length) {
        return this.cities;
      }
      const allowed = new Set(this.allowedCityIds.map(String));
      return this.cities.filter((city) => allowed.has(String(city.id)));
    },
  },
  mounted() {
    if (this.autofocus) {
      this.focusInput();
    }
  },
  methods: {
    focusInput() {
      try {
        this.$refs.cityAutocomplete.focusInput();
      } catch (error) {
        console.info("Cant auto focus cityAutocomplete input");
      }
    },
    onFocus() {
      this.openOnFocus = false;
      this.getGeolocation();
      this.fetchCities();
      this.$emit("focus");
    },
    blur() {
      this.openOnFocus = !this.openOnFocus;
      this.$refs.cityAutocomplete.isActive =
        !this.$refs.cityAutocomplete.isActive;
    },
  },
};
</script>
